import { ModalV3 } from '@jouzen/ecom-components';

import Video from '@/app/components/Video';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const Gen3VideoModal = (): JSX.Element => {
  const { or3VideoVisible, setOr3VideoVisible } = useSizingPageModalContext();
  const toggleModal = () => {
    setOr3VideoVisible(false);
  };

  return (
    <ModalV3
      isOpen={or3VideoVisible}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gen3-sizing-video-wrapper">
          <Video
            altImage={{
              src: 'sizing/alt_img_for_video',
              fill: true,
              alt: 'sizing_video_alt',
              format: 'png',
              sizes: '100vw',
            }}
            captions={[
              {
                label: 'English',
                lang: 'en',
                src: '/captions/captions-en.vtt',
              },
            ]}
            className="size-full"
            contentTitle="sizing_video"
            location="sizing-hero"
            playVideo={or3VideoVisible}
            src="sizing/sizing_video.mp4"
            type="video/mp4"
            poster="https://ourahealth.imgix.net/sizing/video-poster-or3.png?s=87e647fea6e7ba875d4584b02d1f4bb3"
          />
        </div>
      </div>
    </ModalV3>
  );
};

export default Gen3VideoModal;
